import { render, staticRenderFns } from "./CardRedWave.vue?vue&type=template&id=ddc7fd88&scoped=true"
import script from "./CardRedWave.vue?vue&type=script&lang=js"
export * from "./CardRedWave.vue?vue&type=script&lang=js"
import style0 from "./CardRedWave.vue?vue&type=style&index=0&id=ddc7fd88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddc7fd88",
  null
  
)

export default component.exports